import { render, staticRenderFns } from "./wxhealthyscheme.vue?vue&type=template&id=3878d9d0&scoped=true&"
import script from "./wxhealthyscheme.vue?vue&type=script&lang=js&"
export * from "./wxhealthyscheme.vue?vue&type=script&lang=js&"
import style0 from "./wxhealthyscheme.vue?vue&type=style&index=0&id=3878d9d0&lang=scss&scoped=true&"
import style1 from "./wxhealthyscheme.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878d9d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3878d9d0')) {
      api.createRecord('3878d9d0', component.options)
    } else {
      api.reload('3878d9d0', component.options)
    }
    module.hot.accept("./wxhealthyscheme.vue?vue&type=template&id=3878d9d0&scoped=true&", function () {
      api.rerender('3878d9d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxhealthyscheme.vue"
export default component.exports